"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBOmnibarPushNotifications = void 0;
var jwtDecode = require("jwt-decode");
var auth_1 = require("../auth");
var interop_1 = require("../shared/interop");
var omnibar_script_loader_1 = require("./omnibar-script-loader");
var omnibar_toast_container_1 = require("./omnibar-toast-container");
var connectArgs;
var pushNotificationsConnected = false;
var registerPromise;
var notificationSvcIds = {
    admin: {
        requiresNotif: false,
    },
    chrch: {
        requiresNotif: false,
    },
    donorcentrics: {
        requiresNotif: false,
    },
    faith: {
        requiresNotif: true,
    },
    fenxt: {
        requiresNotif: true,
    },
    gmk: {
        requiresNotif: false,
    },
    gsrch: {
        requiresNotif: true,
    },
    lst: {
        requiresNotif: false,
    },
    marketplace: {
        requiresNotif: false,
    },
    merchservices: {
        requiresNotif: false,
    },
    mpebill: {
        requiresNotif: false,
    },
    renxt: {
        requiresNotif: false,
    },
    skydev: {
        requiresNotif: false,
    },
    skydevhome: {
        requiresNotif: false,
    },
    skyux: {
        requiresNotif: false,
    },
    tcs: {
        requiresNotif: true,
    },
    edu: {
        requiresNotif: false,
    },
    highered: {
        requiresNotif: false,
    },
    '1bbfun': {
        requiresNotif: false,
    },
};
function initToastContainer(args) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, omnibar_toast_container_1.BBOmnibarToastContainer.init({
                        envId: args.envId,
                        leId: args.leId,
                        navigateCallback: args.handleNavigate,
                        navigateUrlCallback: args.handleNavigateUrl,
                        openMenuCallback: args.openPushNotificationsMenu,
                        pushNotificationsChangeCallback: args.handlePushNotificationsChange,
                        svcId: args.svcId,
                        url: interop_1.BBAuthInterop.getCurrentUrl(),
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function tokenContainsNotif(envId, leId) {
    return __awaiter(this, void 0, void 0, function () {
        var token, err_1, decodedToken, entitlements;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, auth_1.BBAuth.getToken({
                            disableRedirect: true,
                            envId: envId,
                            leId: leId,
                            permissionScope: 'Notifications',
                        })];
                case 1:
                    token = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    return [2 /*return*/, false];
                case 3:
                    decodedToken = jwtDecode(token);
                    entitlements = decodedToken['1bb.entitlements'];
                    if (entitlements) {
                        entitlements = Array.isArray(entitlements) ? entitlements : [entitlements];
                        return [2 /*return*/, entitlements.indexOf('notif') > -1];
                    }
                    return [2 /*return*/, false];
            }
        });
    });
}
var BBOmnibarPushNotifications = /** @class */ (function () {
    function BBOmnibarPushNotifications() {
    }
    BBOmnibarPushNotifications.connect = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var notificationsEnabled;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!pushNotificationsConnected) return [3 /*break*/, 5];
                        connectArgs = args;
                        pushNotificationsConnected = true;
                        if (window.BBNotificationsClient) {
                            registerPromise = Promise.resolve();
                        }
                        else {
                            registerPromise = omnibar_script_loader_1.BBOmnibarScriptLoader.registerScript(BBOmnibarPushNotifications.NOTIFICATIONS_CLIENT_URL);
                        }
                        return [4 /*yield*/, registerPromise];
                    case 1:
                        _a.sent();
                        window.BBNotificationsClient.BBNotifications.init({
                            tokenCallback: function () {
                                return auth_1.BBAuth.getToken({
                                    disableRedirect: true,
                                    envId: args.envId,
                                    leId: args.leId,
                                });
                            },
                        });
                        return [4 /*yield*/, this.pushNotificationsEnabled()];
                    case 2:
                        notificationsEnabled = _a.sent();
                        if (!notificationsEnabled) return [3 /*break*/, 4];
                        return [4 /*yield*/, initToastContainer(args)];
                    case 3:
                        _a.sent();
                        window.BBNotificationsClient.BBNotifications.addListener(args.notificationsCallback);
                        _a.label = 4;
                    case 4:
                        if (args.showVerticalNav) {
                            window.BBNotificationsClient.BBNotifications.addCustomMessageListener({
                                callback: args.customMessageCallback,
                                customMessageType: 'ui-config-global-settings-update',
                            });
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BBOmnibarPushNotifications.disconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!pushNotificationsConnected) return [3 /*break*/, 2];
                        connectArgs = undefined;
                        omnibar_toast_container_1.BBOmnibarToastContainer.destroy();
                        return [4 /*yield*/, registerPromise];
                    case 1:
                        _a.sent();
                        window.BBNotificationsClient.BBNotifications.destroy();
                        registerPromise = undefined;
                        pushNotificationsConnected = false;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BBOmnibarPushNotifications.updateNotifications = function (notifications) {
        window.BBNotificationsClient.BBNotifications.updateNotifications(notifications);
    };
    BBOmnibarPushNotifications.pushNotificationsEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var notificationSvcId;
            return __generator(this, function (_a) {
                if (pushNotificationsConnected) {
                    notificationSvcId = notificationSvcIds[connectArgs.svcId];
                    if (notificationSvcId) {
                        return [2 /*return*/, (!notificationSvcId.requiresNotif ||
                                tokenContainsNotif(connectArgs.envId, connectArgs.leId))];
                    }
                }
                return [2 /*return*/, false];
            });
        });
    };
    BBOmnibarPushNotifications.NOTIFICATIONS_CLIENT_URL = 'https://sky.blackbaudcdn.net/static/notifications-client/1/notifications-client.global.min.js';
    return BBOmnibarPushNotifications;
}());
exports.BBOmnibarPushNotifications = BBOmnibarPushNotifications;
